import { goBack } from "assets/icons";
import styled from "@emotion/styled";
import { Card, Col, Form, message, Row, Typography, UploadFile } from "antd";
import { useGetProductById, useUpdateProduct } from "hooks/useProduct";
import { FC, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAppDispatch } from "store";
import { setLoading } from "store/slices/loadingSlice";
import {
  AttributeInput,
  UpdateProductInput,
  PriceProductByIdResponse,
} from "services/interface";
import MainUpdateProduct from "./MainUpdateProduct";
import { backendUrl } from "config";
import UpdateProductProduct from "./UpdateProductFooter";
//import { useQueryClient } from "react-query";
import _ from "lodash";

interface UpdateProductProps {
  id: string;
}

const UpdateProduct: FC<UpdateProductProps> = ({ id }) => {
  const { data, isLoading, isError } = useGetProductById(id);
  const navigate = useNavigate();
  const dispatch = useAppDispatch();

  const { mutate, isPending: mutateLoading } = useUpdateProduct();

  const [attribute, setAttribute] = useState<AttributeInput[]>([]);
  const [variants, setVariants] = useState<VariantsInput>([]);
  const [prices, setPrices] = useState<PricesInput>([]);
  const [images, setImages] = useState<UploadFile[]>();
  //const queryClient = useQueryClient();
  const [checkIsActive, setCheckIsActive] = useState<boolean>(false);
  const [is_guid, setIsGuid] = useState<boolean>(false);
  const [content, setContent] = useState<string>("");
  const [is_inventory, setIsInventory] = useState<boolean>(false);

  console.log("หน้า update variants", variants);

  const [form] = Form.useForm();

  const onFinish = (values: any) => {
    // console.log("Updatevalues", values);
    // console.log("Updateattribute", attribute);
    console.log("Updatevariants", variants);
    // console.log("Updateprices", prices);

    if (checkIsActive) {
      //_.isEmpty(attribute) ||
      if (
        _.isEmpty(variants) ||
        _.isEmpty(prices) ||
        _.isEmpty(values.category_id) ||
        values.description === "<p></p>\n"
      ) {
        // if(_.isEmpty(attribute)){
        //   message.error("กรุณาเพิ่มคุณลักษณะสินค้า");
        // }
        if (_.isEmpty(variants)) {
          message.error("กรุณาเพิ่มตัวเลือกสินค้า");
        }
        if (_.isEmpty(values.category_id)) {
          message.error("กรุณาเพิ่มหมวดหมู่สินค้า");
        }
        if (values.description === "<p></p>\n") {
          form.setFieldsValue({
            description: "",
          });
          form.validateFields({});
          // form.isFieldValidating("description");
          message.error("กรุณาเพิ่มคำอธิบายสินค้า");
        }
        return;
      }
    }

    console.log("description--->", values.description);

    let new_main_images: any = [];

    if (values.main_images) {
      new_main_images = values.main_images.map((item: any) => {
        return item.id;
      });
    }

    console.log("prices", prices);
    console.log("variants", variants);

    //validate prices ต้องไม่เป็น 0
    const hasZeroPrice = prices.some(
      (price) =>
        price.factory_price === 0 ||
        price.retail_price === 0 ||
        price.wholesale_price === 0
    );

    if (hasZeroPrice) {
      message.error("ราคาสินค้าต้องไม่เป็น 0");
      return;
    }
    

    const updateProductInput: UpdateProductInput = {
      id: id,
      recomended_retail: values.recomended_retail,
      name: values.name,
      description: content,
      category_id: values.category_id,
      main_images: new_main_images,
      prices: prices,
      variants: variants,
      properties: attribute,
      is_active: values.is_active,
      retail_type: values.retail_type,
      video_url: values.video_url,
      is_guid: is_guid,
    };

    console.log("updateProductInput", updateProductInput);

    mutate(updateProductInput, {
      onSuccess: (data) => {
        message.success("แก้ไขสินค้าสำเร็จ");
        // queryClient.invalidateQueries("getProductList");
        // queryClient.invalidateQueries("getProductListInActive");
        // queryClient.invalidateQueries("getProductListActive");
        // queryClient.invalidateQueries(`product${id}`);
      },
      onError: () => {
        message.error("แก้ไขสินค้าไม่สำเร็จ");
      },
    });
  };

  useEffect(() => {
    if (isLoading) {
      dispatch(setLoading(true));
    } else {
      dispatch(setLoading(false));
    }
  }, [isLoading]);

  useEffect(() => {
    if (isError) {
      navigate("/not-found");
    }
  }, [isError]);

  useEffect(() => {
    form.setFieldsValue({
      description: content,
    });
  }, [content, form]);

  useEffect(() => {
    form.setFieldsValue({
      description: content,
    });
  }, [content, form]);

  useEffect(() => {
    if (data) {
      setAttribute(data.product.properties);
      setVariants(data.product.variants);
      setCheckIsActive(data.product.is_active);
      setIsGuid(data.product.is_guid);
      setIsInventory(data.product.is_inventory);

      let apiPrices: PricesInput = [];
      data.product.prices.map((item: PriceProductByIdResponse) => {
        apiPrices.push({
          variant_1_item_id: item.variant_1_item_id,
          variant_2_item_id: item.variant_2_item_id,
          factory_price: Number(item.factory_price),
          retail_price: Number(item.retail_price),
          wholesale_price: Number(item.wholesale_price),
        });
      });

      setPrices(apiPrices);

      // console.log("prices-->", data.product.is_active);

      const main_images_item: UploadFile[] = data.product.main_images.map(
        (item: string) => {
          return {
            uid: item,
            name: data.product.name,
            status: "done",
            id: item,
            url: `${backendUrl}images/${item}`,
          };
        }
      );

      setImages(main_images_item);
      setContent(data.product.description);

      let description =
        data.product.description === "<p></p>\n"
          ? ""
          : data.product.description;

      form.setFieldsValue({
        name: data.product.name,
        description: description,
        category_id: data.product.category_id,
        main_images: main_images_item,
        recomended_retail: data.product.recomended_retail,
        is_active: data.product.is_active,
        retail_type: data.product.retail_type.map((item: any) => {
          return item.toString();
        }),
        video_url: data.product.video_url,
        is_guid: data.product.is_guid,
      });
    }
  }, [data, form]);

  return (
    <>
      <Form form={form} onFinish={onFinish}>
        <Row className="rowgap-vbox" gutter={[24, 0]}>
          <Col span={24}>
            <Card bordered={false} className="criclebox h-full tabs-mobile">
              <HeaderTabs>
                <IconWrapper
                  onClick={() => {
                    navigate("/manage-product");
                  }}
                >
                  <SpanIcon>{goBack}</SpanIcon>
                </IconWrapper>
                <Typography.Title level={5}>แก้ไขสินค้า</Typography.Title>
                <RightIconWrapper></RightIconWrapper>
              </HeaderTabs>
              <WrapperAll>
                <MainUpdateProduct
                  form={form}
                  onFinish={onFinish}
                  attribute={attribute}
                  setAttribute={setAttribute}
                  variants={variants}
                  setVariants={setVariants}
                  prices={prices}
                  setPrices={setPrices}
                  images={images ?? undefined}
                  checkIsActive={checkIsActive}
                  setCheckIsActive={setCheckIsActive}
                  setContent={setContent}
                  content={content}
                  is_guid={is_guid}
                  setIsGuid={setIsGuid}
                  is_inventory={is_inventory}
                  setIsInventory={setIsInventory}
                />
              </WrapperAll>
            </Card>
          </Col>
        </Row>
        <UpdateProductProduct loading={mutateLoading} is_guid={is_guid} is_inventory={is_inventory} />
      </Form>
    </>
  );
};

export default UpdateProduct;

const HeaderTabs = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px;
  flex-direction: row;
  border-bottom: 1px solid #efefef;
`;

const IconWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 30px;
  border-radius: 6px;
  background-color: #ffffff;
  cursor: pointer;
  transition: all 0.3s ease-in-out;
  &:hover {
    background-color: #efefef;
  }
`;

const SpanIcon = styled.span`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
`;

const RightIconWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
`;

const WrapperAll = styled.div`
  display: block;
  width: 100%;
  overflow-y: auto;
  overflow-x: hidden;
`;
